import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertInput, IonicModule, ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { ITEMS_LIMIT, getListAsync, innerScrollEl, returnScrollPosition, scrollToSelected } from 'src/app/app.utils';
import { OwnerSelectComponent } from 'src/app/components/owner-select/owner-select.component';
import { ProjectCreate, UserGroup } from 'src/app/model';
import { UserProfile } from 'src/app/providers';
import { Timezone, getUserTimeZone, timezoneList } from 'src/app/providers/timezone';

@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, CommonModule, IonicSelectableComponent, OwnerSelectComponent],
})
export class CreateProjectModalComponent implements OnInit {
  public timezones: AlertInput[];
  public timezone: AlertInput;
  public name: string;

  public owner: number;
  public admin = false;
  public owners: UserGroup[];

  private page = 1;

  @Output() updatedName = new EventEmitter<string>();

  constructor(
    private modalController: ModalController,
    private userProfile: UserProfile,
  ) { }

  async ngOnInit() {
    this.admin = await this.userProfile.isAdmin();

    this.timezones = timezoneList().map((t) => ({
      name: t.tzCode,
      type: 'radio',
      label: t.label,
      value: t.label,
    }));

    const userTimezone = getUserTimeZone();
    if (userTimezone) {
      const inputsTimeZone = this.timezones.find((tz) => tz.name === userTimezone);

      if (inputsTimeZone) {
        this.timezone = inputsTimeZone;
      }
    } else {
      this.timezone = this.timezones[0];
    }
  }

  public changeName = () => this.updatedName.emit(this.name);

  public timezoneChange(event: {component: IonicSelectableComponent, value: AlertInput}) {
    this.timezone = event.value;
  }

  public back() {
    this.modalController.dismiss();
  }

  public async create() {
    const resultModal: ProjectCreate = {
      owner_id: this.owner,
      timezone: this.timezone.name,
      name: this.name,
    };
    this.modalController.dismiss(resultModal);
  }

  public filterTimezones(timezones: AlertInput[], text: string) {
    return timezones.filter(timezone => {
      return timezone.name?.toLowerCase().includes(text.trim().toLowerCase());
    });
  }

  public searchTimezone(event: {
    component: IonicSelectableComponent,
    text: string
  }) {
    const text = event.text.trim().toLowerCase();
    event.component.startSearch();

    if (!text) {
      event.component.items = this.timezones.slice(0, this.page * ITEMS_LIMIT);
      event.component.endSearch();
      scrollToSelected();
      return;
    }

    event.component.items = this.filterTimezones(this.timezones, text);
    event.component.enableInfiniteScroll();
    event.component.endSearch();
  }

  public getMoreTimezones(event: {
    component: IonicSelectableComponent,
    text: string
  }) {
    const scrollEl = innerScrollEl();

    if (!scrollEl) {
      return;
    }

    const scrollVal = scrollEl.scrollTop;

    const text = (event.text || '').trim().toLowerCase();

    if (this.page >= Math.ceil(timezoneList().length / ITEMS_LIMIT)) {
      event.component.disableInfiniteScroll();
      return;
    }

    getListAsync<Timezone>(this.timezones as Timezone[], this.page, ITEMS_LIMIT, 0).subscribe((timezones) => {
      timezones = event.component.items.concat(timezones);

      if (text) {
        timezones = this.filterTimezones(timezones, text) as Timezone[];
      }

      event.component.items = timezones;
      event.component.endInfiniteScroll();
      this.page++;

      if (!text) {
        returnScrollPosition(scrollEl, scrollVal);
      }
    });
  }

  public onOpen() {
    scrollToSelected();
  }

}
